<template>
  <el-container v-title data-title="天乔新生" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>其它功能</el-breadcrumb-item>
                <el-breadcrumb-item>天乔新生</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="姓名">
                  <el-input v-model="searchForm.studentRealName" placeholder="名称"></el-input>
                </el-form-item>
                <el-form-item label="每页条数">
                  <el-select v-model="pageSize" @change="handleSizeChange" style="width:80px">
                    <el-option v-for="(item, index) in pageSizes" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getMeetingFaceList">查询</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="studentRealName" label="姓名" width="120"></el-table-column>
          <el-table-column prop="studentIdCardNo" label="身份证号码" width="200"></el-table-column>
          <el-table-column prop="insertTime" label="创建时间" width="180"></el-table-column>
          <el-table-column prop="insertNickName" label="创建人" width="180"></el-table-column>
          <el-table-column prop="updateTime" label="最后修改时间" width="180"></el-table-column>
          <el-table-column prop="updateNickName" label="最后修改人" width="180"></el-table-column>
          <el-table-column label="人脸图片" width="100">
            <template slot-scope="scope">
              <img v-if="scope.row.picUrl != null && scope.row.picUrl.length > 0" :src="GLOBAL.picUrl + scope.row.picUrl" width="64" height="36" @click="openPicDialog(GLOBAL.picUrl + scope.row.picUrl)"/>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="getMeetingFaceList"
            :current-page.sync="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :total="total"
            layout="total,sizes,prev,pager,next" >
          </el-pagination>
        </div>
      </el-main>
      <el-dialog
        :visible.sync="picDialogVisible"
        width="680px"
        :before-close="handleClose"
        :close-on-click-modal="true">
        <img width="640" :src="picUrlOnPicDialog" />
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 50, 100, 150, 200, 300, 500, 1000, 2000],
      total: 0,
      searchForm: {
        schoolId: '',
        studentRealName: ''
      },
      schoolList: [],
      picDialogVisible: false,
      picUrlOnPicDialog: ''
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getMeetingFaceList()
    },
    openPicDialog (picUrl) {
      this.picUrlOnPicDialog = picUrl
      this.picDialogVisible = true
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
            if (_this.schoolList.length > 0) {
              _this.searchForm.schoolId = _this.schoolList[0].id
              _this.getMeetingFaceList()
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getMeetingFaceList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/tianqiao/temp/meetingFace/listForPc',
        this.$qs.stringify({
          schoolId: _this.searchForm.schoolId,
          studentRealName: _this.searchForm.studentRealName

        })
      ).then(res => {
        if (res.data.status === 200) {
          if (res.data.data != null) {
            _this.tableData = res.data.data.list
          } else {
            _this.tableData = []
          }
        } else {
          this.$message.error(res.data.message)
        }
      })
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/TianqiaoTempMeetingFace.vue